/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { Flex, Box } from 'rebass';

import { Typography } from '../atoms';

export const RadialBar = ({
  width,
  total,
  amount,
  content,
  bgColor,
  showOverall,
}) => {
  const overflow = total - amount < 0;
  let percentage = overflow ? 100 : 0;

  if (total && amount) {
    percentage = (amount / total) * 100;
  }

  return (
    <Chart width={width} bg={bgColor}>
      <svg viewBox="0 0 36 18">
        <path
          stroke="#E6E6E6"
          strokeWidth="3.5"
          strokeLinecap="round"
          fill="none"
          d="M2 18 A16 16 0 0 1 34 18"
        />
        <path
          className="filledCircle"
          stroke={overflow ? 'green' : '#7B61FF'}
          strokeWidth="3.5"
          strokeLinecap="round"
          fill="none"
          d="M2 18 A16 16 0 0 1 34 18"
          strokeDasharray={`${(percentage / 100) * 50}, 100`}
          style={{ transition: 'stroke-dasharray 0.6s ease-out' }}
        />
      </svg>
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        p={10}
      >
        <Typography
          mb="5px"
          fontSize={20}
          fontWeight={700}
          lineHeight={1}
          textAlign="center"
        >
          {showOverall ? `${amount}/${total}` : `${Math.round(percentage)}%`}
        </Typography>
        <Typography fontSize={10} textAlign="center" lineHeight={1}>
          {content}
        </Typography>
      </Flex>
    </Chart>
  );
};

RadialBar.defaultProps = {
  width: 112,
  total: 0,
  amount: 0,
  content: '',
  bgColor: 'rgba(255, 255, 255, 0)',
};

RadialBar.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  content: PropTypes.node,
  bgColor: PropTypes.string,
  showOverall: PropTypes.bool,
};

RadialBar.defaultProps = {
  showOverall: true,
  width: 112,
};

const percentageAnimation = keyframes`
  0% {
    stroke-dasharray: 0 100;
  }
`;

const Chart = styled(Box)`
  position: relative;
  width: ${({ width }) => width}px;
  height: ${({ width }) => width / 2}px;
  svg {
    width: 100%;
    height: 100%;
  }
  .filledCircle {
    animation: ${percentageAnimation} 1s ease-out forwards;
  }
  > div {
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    text-align: center;
  }
`;
